import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthService);

  public login(): void {
    this._authService
      .loginWithRedirect()
      .pipe(tap(() => this._router.navigate(['/relations'])))
      .subscribe();
  }

  public logout(): void {
    this._authService.logout({
      logoutParams: { returnTo: document.location.origin },
    });
  }

  public isLoggedIn(): Observable<boolean> {
    return this._authService.isAuthenticated$;
  }
}
